













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
} from 'ag-grid-community';
import { AgGridVue } from 'ag-grid-vue';
import config from '@/config/index';
import { headers } from '@/pantallas/SucursalVirtual/Cotizador/SolucionesHeaders';
import SucursalVirtuallInstance from '@/pantallas/SucursalVirtual/comunes/instances';

@Component({
  name: 'Datatables',
  components: {
    GridComponent: AgGridVue,
  },
})
export default class DatatableSolu extends Vue {
  @Prop({ default: [] }) dataTable!: any[];
  loadingService = new LoadingService();
  name: 'Datatables';
  gridOptions: GridOptions;
  localeText: any = config.agGridTextos;
  columnDefs: Array<ColDef> = [];
  gridApi: GridApi;
  serverSide: any;
  columnApi: ColumnApi;
  clientId: any = '';
  responseLink: any;
  $notify: any;
  $snotify: any;
  headers: any = headers;

  rowsPerPageItems = [
    10,
    25,
    50,
    100,
    { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
  ];

  constructor() {
    super();
    this.clientId = localStorage.getItem('clienteDefecto');
    this.gridOptions = {
      rowSelection: 'single',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 10000,
      localeText: this.localeText,
      paginationAutoPageSize: false,
      columnDefs: this.headers,
      overlayNoRowsTemplate: 'Lo siento, no hay datos para mostrar :(',
      onGridReady: this.handleGridReady,
      suppressCsvExport: false,
      onGridSizeChanged: (event: any) => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  async handleGridReady(event: GridReadyEvent) {
    let self = this;
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridOptions.api.setColumnDefs(this.headers);
    this.gridApi.setRowData(this.dataTable);
    this.gridApi.setDomLayout('autoHeight');
    SucursalVirtuallInstance.$off('loadDataSolu');
    SucursalVirtuallInstance.$on('loadDataSolu', function() {
      console.log(self.dataTable);
      self.gridApi.setRowData(self.dataTable);
      self.gridApi.setDomLayout('autoHeight');
      self.gridApi.refreshCells();
    });
  }
}
